import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = () => {};
}
if (environment.googleAnalyticsEnable) {
  const scriptGa = window.document.createElement('script');
  scriptGa.async = true;
  scriptGa.src = `./assets/js/${environment.gaId}.js`;
  window.document.head.appendChild(scriptGa);
  const scriptConfig = window.document.createElement('script');
  scriptConfig.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', "${environment.gaId}", {
      send_page_view: false,
      allow_ad_personalization_signals: false
    });
  `;
  window.document.head.appendChild(scriptConfig);
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
